import React from "react"
import CMSRender from "aldoo-ra/CMS/cms-render"
import Typography from "aldoo-ra/Typography"
import Button from "aldoo-ra/Button"

const CustomerSupportCard = () => {
  return (
    <CMSRender
      contentType="AccountSupportCard"
      match={{ "content.name": "CustomerSupportCard" }}
      renderItem={(card) => {
        return (
          // Same height as the one of AccountTypeCard, for alignment consistency.
          <div className="w-full h-[280px] flex flex-col items-start justify-between bg-paper rounded-[50px] px-[40px] py-[35px] shadow-card_shadow">
            {/* Title with Icon */}
            <div className="flex gap-[14px]">
              <img 
                src={card.title_icon} 
                alt="Account type" 
                className="w-[30px] h-[30px]" 
              />

              <Typography 
                variant="h3" 
                className="text-text"
              >
                {card.title}
              </Typography>
            </div>

            <Typography
              variant="body1"
              className="w-full mt-0"
            >
              {card.info}
            </Typography>

            {/* CTA Button (add logic) */}
            <Button variant="secondary_s">
              {card.cta[0].label}
            </Button>
          </div>
        )
      }}
    />
  );
};

export default CustomerSupportCard;
